import { createContext } from 'react';

export interface AdDataFreshnessScope {
  page: string;
  active: boolean;
  reportLoading: boolean;
}

// Delivery filter bars share the page's activity and aggregate loading state.
export const AdDataFreshnessContext = createContext<AdDataFreshnessScope | null>(null);
